import Clock from "assets/icons/Clock.svg";
import classNames from "classnames";
import { ORGANIZATIONS, QUESTION_TYPE } from "constant";
import { useMemo } from "react";
import { storage } from "services/storage";

/**
 * This component consider time in seconds
 */
export const Timer = ({ time = 0, onUpdate, type, isMcq = false }) => {
  const organization = storage.get.org();
  const spotlightOrgFlag = organization === ORGANIZATIONS.SPOTLIGHT

  const isSpeech = useMemo(
    () =>
      [
        QUESTION_TYPE.SPEECH_SCRIPTED,
        QUESTION_TYPE.SPEECH_SPONTANEOUS,
      ].includes(type),
    [type]
  );

  return (
    <>
      {
        !spotlightOrgFlag
          ? <img src={Clock} alt="" className="mr-[3px]" />
          : <></>
      }
      <span
        className={classNames(
          "text-sm font-medium text-cocoa-brown",
          "sm:text-base"
        )}
      ></span>
      <div className={classNames("", {
        "text-[#fff] text-[14px] font-normal": (isSpeech || isMcq) && spotlightOrgFlag,
        "hidden": time === null && spotlightOrgFlag
      })}>
        {time !== null
          ? new Date(time * 1000).toISOString().substring(14, 19)
          : "--:--"}
      </div>
    </>
  );
};
